<template>
  <div class="container-fluid bg-white container-fluid px-4 py-5 rounded-4" :class="{ 'mis-comisiones': activeTab === 'comisiones' }">
    <div class="d-flex justify-content-between align-items-baseline">
      <h1 class="m-0">{{ $t("mis_datos.titulo") }}</h1>
      <DxButton v-bind="optSignOutButton" cssClass="align-self-start"></DxButton>
    </div>
    <MisDatosTab v-model:active-tab="activeTab" />
  </div>
</template>

<script setup lang="ts">
import MisDatosTab, { type MisDatosTabId } from "@/components/mis-datos/MisDatosTab.vue";
import { DxButton } from "devextreme-vue";
import { useAuthentication } from "@/.shared/services/auth";
import { useIntl } from "@/.shared/services/i18n";
import { ref } from "vue";

const auth = useAuthentication();
const intl = useIntl();
const activeTab = ref<MisDatosTabId>("facturas");

const optSignOutButton: DxButton = {
  text: intl.i18n.t("shared.ui.buttons.logout"),
  icon: "fa-light fa-sign-out",
  onClick: async function () {
    auth.logout(import.meta.env.VITE_BASE_URL);
  }
};
</script>

<style lang="scss" scoped>
.mis-comisiones {
  max-height: 100%;
  overflow: hidden;
  height: 100%;
}

@media (max-width: 1200px) {
  .mis-comisiones {
    max-height: 100%;
    overflow: auto;
    height: auto;
  }
}
</style>
